var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 64,
    viewBox: "0 0 429 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.83252 0.800781L64.5 56.4567H413",
    stroke: "url(#paint0_linear_3052_1047)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.5 63.9609C424.918 63.9609 428.5 60.3792 428.5 55.9609C428.5 51.5427 424.918 47.9609 420.5 47.9609C416.082 47.9609 412.5 51.5427 412.5 55.9609C412.5 60.3792 416.082 63.9609 420.5 63.9609Z",
    fill: "#71253C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1047",
    x1: 413,
    y1: 37.9569,
    x2: 45.4998,
    y2: 37.9569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000999756,
    stopColor: "#71253C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#32273C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages2);
export default __webpack_public_path__ + "static/media/line-Advantages2.5dee8efaf77fe29ca70408e327cbdf57.svg";
export { ForwardRef as ReactComponent };